"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    loading: "Loading WHOIS data...",
    abuseContact: "Abuse Contact",
    owner: "Owner",
    notSpecified: "Not Specified",
};
